"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var User = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12.0596,3.9834 C11.8306,3.9834 10.5436,4.0104 9.6516,4.9684 C8.9556,5.7164 8.6576,6.8544 8.7656,8.3504 C8.8366,9.9844 9.5606,10.9824 10.1556,11.5344 C10.4376,11.7944 10.6236,12.1494 10.6786,12.5324 C10.7836,13.2504 10.3416,13.9424 9.6276,14.1764 L7.7266,14.8074 C4.9976,15.7044 5.0146,17.7104 5.0166,17.7954 L5.0176,18.4834 C5.0176,18.7584 5.2416,18.9834 5.5176,18.9834 L18.5166,18.9834 C18.7916,18.9834 19.0166,18.7584 19.0166,18.4834 L19.0166,17.8114 C19.0186,17.7104 19.0356,15.7044 16.3056,14.8074 L14.3936,14.1724 C13.7666,13.9664 13.3316,13.3874 13.3366,12.7654 C13.3396,12.2984 13.5376,11.8494 13.8776,11.5344 C14.4726,10.9824 15.1966,9.9844 15.2676,8.3654 C15.3756,6.8544 15.0776,5.7164 14.3816,4.9684 C13.4896,4.0104 12.2036,3.9834 12.0596,3.9834 M18.5166,19.9834 L5.5176,19.9834 C4.6896,19.9834 4.0176,19.3104 4.0176,18.4834 L4.0176,17.8114 C4.0126,17.7164 3.9446,14.9984 7.4146,13.8584 L9.3156,13.2274 C9.5626,13.1454 9.7236,12.9094 9.6896,12.6754 C9.6666,12.5184 9.5906,12.3744 9.4766,12.2674 C8.7436,11.5874 7.8516,10.3674 7.7676,8.4084 C7.6396,6.6374 8.0276,5.2474 8.9196,4.2874 C10.0756,3.0464 11.6666,2.9834 11.9746,2.9834 C12.3666,2.9834 13.9576,3.0464 15.1136,4.2874 C16.0056,5.2464 16.3936,6.6374 16.2656,8.4224 C16.1816,10.3674 15.2896,11.5874 14.5576,12.2664 C14.4186,12.3964 14.3376,12.5814 14.3366,12.7734 C14.3346,12.9624 14.4906,13.1524 14.7066,13.2234 L16.6176,13.8584 C20.0886,14.9984 20.0206,17.7164 20.0156,17.8314 L20.0166,18.4834 C20.0166,19.3104 19.3436,19.9834 18.5166,19.9834", fillRule: "evenodd" })));
};
User.displayName = 'User';
exports.default = User;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=User.js.map